module.exports = __webpack_public_path__ + "static/img/ecomsolid.31d7d7f3.png";